import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-check",
  "use": "icon-cl-check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-check\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.632 2.196c.41.322.49.924.177 1.346l-7.467 10.08a.919.919 0 0 1-1.402.097l-4.667-4.8a.98.98 0 0 1 0-1.358.915.915 0 0 1 1.32 0l3.912 4.024 6.82-9.207a.916.916 0 0 1 1.307-.182Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol